import './PublicLead.scss';
import InputMask from 'react-input-mask'
import React, { useLayoutEffect, useEffect, useState, useMemo, useRef } from 'react'
import { useParams } from 'react-router-dom'
import SettingsService from '../../../services/api/settings.service'
import ThemeService from '../../../services/api/theme.service'
import AppointmentService from '../../../services/api/appointment.service'
import toast from 'react-hot-toast'
import LeadSourceService from '../../../services/api/lead-source.service';
import FormValidatorService from '../../../services/validator/form-validator.service';
import ValidationConstant from '../../../services/validator/validation.constant';
import HPTSelect from '../../templates/components/HPTSelect';
import APIResponse from '../../templates/components/APIResponse';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Utilities from '../../../services/commonservice/utilities'
const LeadFormConfig = {
    config: {
        'FirstName': {
            required: { name: ValidationConstant.patient.add.firstName.name },
            maxlength: {
                name: ValidationConstant.patient.add.firstName.name,
                max: ValidationConstant.patient.add.firstName.maxLength.toString()
            },
            // minlength: {
            //     name: ValidationConstant.patient.add.firstName.name,
            //     min: ValidationConstant.patient.add.firstName.minLength.toString()
            // },
            pattern: {
                name: ValidationConstant.patient.add.firstName.name,
            }
        },
        'LastName': {
            required: { name: ValidationConstant.patient.add.lastName.name },
            maxlength: {
                name: ValidationConstant.patient.add.lastName.name,
                max: ValidationConstant.patient.add.lastName.maxLength.toString()
            },
            // minlength: {
            //     name: ValidationConstant.patient.add.lastName.name,
            //     min: ValidationConstant.patient.add.lastName.minLength.toString()
            // },
            pattern: { name: ValidationConstant.patient.add.lastName.name }
        }, 'Mobile': {
            required: { name: ValidationConstant.patient.add.mobile.name },
            maxlength: {
                name: ValidationConstant.patient.add.mobile.name,
                max: ValidationConstant.patient.add.mobile.maxLength.toString()
            },
            minlength: {
                name: ValidationConstant.patient.add.mobile.name,
                min: ValidationConstant.patient.add.mobile.minLength.toString()
            },
            pattern: {
                name: ValidationConstant.patient.add.mobile.name,
                regex: new RegExp(ValidationConstant.phone_regex)
            }
        },
        'Email': {
            required: { name: ValidationConstant.patient.add.email.name },
            maxlength: {
                name: ValidationConstant.patient.add.email.name,
                max: ValidationConstant.patient.add.email.maxLength.toString()
            },
            minlength: {
                name: ValidationConstant.patient.add.email.name,
                min: ValidationConstant.patient.add.email.minLength.toString()
            },
            pattern: {
                name: ValidationConstant.patient.add.email.name,
                regex: new RegExp(ValidationConstant.email_regex)
            }
        },
        'PracticeLocationId': {
            required: { name: ValidationConstant.patient.add.practiceLocation.name },
        },
    },
    initialFormData: {
        firstName: '',
        lastName: '',
        mobile: '',
        email: '',
        practiceLocationId: null,
        comments: ''
    }
}

const PublicLead = (props) => {
    const siteKey = Utilities.production() ? process.env.REACT_APP_PROD_SITEKEY : process.env.REACT_APP_DEV_SITEKEY //  '6LdlPjAbAAAAAONdr9-VI9hYQDb3ZABbBjkhktNE' //process.env.siteKey;
    return (
        <GoogleReCaptchaProvider reCaptchaKey={siteKey}
            container={{
                parameters: {
                    badge: 'inline',
                }
            }}>
            <LeadForm />
        </GoogleReCaptchaProvider>
    )
}
const LeadForm = (props) => {
    // Params
    // http://localhost:3000/lead/qlWX4WMN/dentacare
    const params = useParams()
    // const params = { providerId: 'qlWX4WMN', providerSlug: 'dentacare' }

    //Function
    const [isLoader, setIsLoader] = useState(true)

    //Branding
    const [logo, setLogo] = useState()
    const [skin, setSkin] = useState()

    // form information
    const [locations, setLocations] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [errorMessage, setErrorMessage] = useState()
    const [formData, setFormData] = useState(LeadFormConfig.initialFormData);
    const [errors, setErrors] = useState({})
    const required = ['firstName', 'lastName', 'mobile', 'email', 'practiceLocationId']
    const [apiResponse, setApiResponse] = useState()
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [isSubmitted, setIsSubmitted] = useState(false);


    const onSuccess = (message) => {
        resetForm();
        setIsSubmitted(true);
    }
    const inputChange = (e) => {
        let newStateObject = { ...formData };
        newStateObject[e.target.name] = e.target.value
        setErrors(FormValidatorService.setErrors(e, errors, LeadFormConfig.config))
        return setFormData(newStateObject);
    };
    const providerId = useMemo(() => {
        return params.providerId
    }, [params])
    const providerSlug = useMemo(() => {
        return params.providerSlug
    }, [params])

    const fetchLogo = () => {
        console.log('fetchLogo')
        if (providerSlug) {
            SettingsService.getProviderSettingsLogo(providerSlug)
                .then(res => {
                    console.log(res)
                    if (res?.data?.logo) {
                        setLogo(res.data.logo)
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }
    }

    const fetchSkin = () => {
        console.log('fetchSkin')
        if (providerSlug) {
            SettingsService.getProviderSettingsSkin(providerSlug)
                .then(res => {
                    console.log(res)
                    if (res?.data?.skin) {
                        setSkin(res.data.skin)
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }
    }


    const resetForm = () => {
        setFormData(LeadFormConfig.initialFormData);
        setErrors({}); // Optionally reset errors as well
        setSelectedLocation(null)
    };

    useEffect(() => {
        console.log('useEffect [providerSlug] 1' + providerSlug)
        fetchLogo()
        fetchSkin()
    }, [providerSlug])

    useEffect(() => {
        console.log('useEffect [providerId]')
        getLocations()
    }, [providerId])

    useLayoutEffect(() => {
        console.log('useLayoutEffect [logo, skin]')
        if (logo && skin) {
            ThemeService.changeTheme(skin)
        }
    }, [logo, skin])

    const getLocations = () => {
        console.log('getLocations')
        if (providerId) {
            AppointmentService.publicPracticeLocationLookup({ parentId: providerId })
                .then(res => {
                    console.log(res)
                    if (Array.isArray(res)) {
                        let newData = [...res]
                        setLocations(newData)

                        if (newData.length > 0) {
                            setSelectedLocation(newData[0])
                            inputChange({
                                target:
                                    { value: newData[0].practiceLocationId, name: 'practiceLocationId' }
                            })
                        }
                        else {
                            setSelectedLocation()
                        }

                        setIsLoader(false)
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }
        else {
            setSelectedLocation()
        }
    }
    const submitHandler = async (data) => {
        setIsLoader(true)
        //console.log(JSON.stringify(data))
        const recaptchaToken = await executeRecaptcha('leadForm');
        //console.log("recaptchaToken::" + recaptchaToken)
        let reqObj = {
            comments: data.comments || null,
            email: data.email || null,
            firstName: data.firstName || null,
            lastName: data.lastName || null,
            mobile: data?.mobile && data?.mobile?.includes("(") ? data.mobile.replace("(", "").replace(")", "").replace("-", "").replace(" ", "") : data.mobile,
            source: data.source || null,
            status: data.status || null,
            assignedToId: data.assignedToId || null,
            metadata: data.metadata || null,
            captcha: recaptchaToken
        }
        return LeadSourceService.publicAddLead(providerId, data?.practiceLocationId, reqObj)
            .then(res => {
                console.log(JSON.stringify(res));
                setApiResponse(res);
            })
            .catch(err => {
                setErrorMessage("Failed to create lead.")
            }).finally(() => {
                setIsLoader(false)
            });
    }

    return (
        <>
            <div className='fill-screen'>
                {isLoader && <div className="ui active dimmer">
                    <div className="ui indeterminate text loader">Loading</div>
                </div>}

                <div className='fill-screen p-3 justify-content-center align-items-stretch'>
                    <div className='container overflow-clip'>
                        <div className='card w-100 p-3'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='row'>
                                        {/* <h5 className='card-header text-center primary-header pt-3'>
                                            Lead Form
                                        </h5>
                                        <div className='col-12 justify-content-center mb-3'>
                                            <div className='nav-image' style={{ backgroundImage: `url(${logo})` }} />
                                        </div> */}
                                        <div className='col-12'>
                                            <div className='card p-3'>
                                                {isSubmitted ? (
                                                    <div className="text-center py-5">
                                                        <h4 className="text-success">Thank you! Your information has been submitted.</h4>
                                                    </div>
                                                ) : (                                                
                                                <div className='d-flex row'>
                                                    <div className="col-md-12 col-12 required field">
                                                        <label>Preferred Practice Location </label>
                                                        <HPTSelect
                                                            className='react-select-container'
                                                            classNamePrefix='react-select'
                                                            options={locations}
                                                            value={selectedLocation}
                                                            isLoading={!locations}
                                                            loadingMessage="Locations are loading..."
                                                            onChange={e => {
                                                                if (e?.practiceLocationId) {
                                                                    setSelectedLocation(e)
                                                                }
                                                                else {
                                                                    setSelectedLocation()
                                                                }
                                                                inputChange({
                                                                    target:
                                                                        { value: e?.practiceLocationId, name: 'practiceLocationId' }
                                                                })
                                                            }}
                                                            getOptionLabel={(option) => option.practiceLocation}
                                                            getOptionValue={(option) => option.practiceLocationId}
                                                        />
                                                        <span className="error-message">{errors?.practiceLocationId}</span>
                                                    </div>
                                                    <div className="col-md-6 col-12 required field">
                                                        <label>First Name</label>
                                                        <input
                                                            placeholder="First Name"
                                                            type="text"
                                                            name="firstName"
                                                            value={formData.firstName}
                                                            onChange={(e) => {
                                                                e.preventDefault();
                                                                inputChange(e);
                                                            }}
                                                            required
                                                        />
                                                        <span className="error-message">{errors.firstName}</span>
                                                    </div>

                                                    <div className="col-md-6 col-12 required field">
                                                        <label>Last Name</label>
                                                        <input
                                                            placeholder="Last Name"
                                                            type="text"
                                                            name="lastName"
                                                            value={formData.lastName}
                                                            onChange={(e) => {
                                                                e.preventDefault();
                                                                inputChange(e);
                                                            }}
                                                            required
                                                        />
                                                        <span className="error-message">{errors.lastName}</span>
                                                    </div>

                                                    <div className="col-md-6 col-12 required field">
                                                        <label>Phone</label>
                                                        <InputMask
                                                            placeholder="Mobile"
                                                            type="text"
                                                            name="mobile"
                                                            mask="(999) 999-9999"
                                                            unmask="true"
                                                            onUnmask
                                                            value={formData.mobile}
                                                            onChange={(e) => {
                                                                e.preventDefault();
                                                                inputChange(e);
                                                            }}
                                                            editable="true"
                                                        />
                                                        <span className="error-message">{errors.mobile}</span>
                                                    </div>
                                                    <div
                                                        className="col-md-6 col-12 required field"
                                                    >
                                                        <label>Email</label>
                                                        <input
                                                            placeholder="Email"
                                                            type="email"
                                                            name="email"
                                                            className="form-control"
                                                            value={formData.email}
                                                            onChange={(e) => {
                                                                e.preventDefault();
                                                                inputChange(e);
                                                            }}
                                                        />
                                                        <span className="error-message">{errors.email}</span>
                                                    </div>
                                                    <div className="col-md-12 col-12 field">
                                                        <label>Comment</label>
                                                        <textarea placeholder="Comment"
                                                            className="form-control"
                                                            value={formData.comments}
                                                            onChange={e => { e.preventDefault(); inputChange(e) }}
                                                            name="comments"
                                                            rows={2}
                                                        ></textarea>
                                                    </div>
                                                    <div className='mt-3 d-flex justify-content-between modal-button-bar'>
                                                        <div className='col-auto'>
                                                            <button className='btn btn-secondary' onClick={e => { e.preventDefault(); resetForm(); }}>Reset</button>
                                                        </div>
                                                        <div className='col-auto'>
                                                            <button className='btn btn-primary' onClick={e => {
                                                                e.preventDefault();
                                                                if (!FormValidatorService.checkForm(errors, formData, required)) {
                                                                    toast.error("Please make sure the form is complete");
                                                                }
                                                                else {
                                                                    submitHandler(formData)
                                                                }
                                                            }}>Submit</button>
                                                        </div>
                                                    </div>
                                                    <div className='col-12 text-center' style={{ color: 'red', marginTop: '10px' }}>
                                                        {errorMessage}
                                                    </div>
                                                </div>
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} successMessage={"Lead created successfully!"} toastOnSuccess={true} />
        </>
    )
}

export default PublicLead
